import { EducationInformation } from './EducationInformation';

export class FellowshipProgramDetail extends EducationInformation {
    directorFirstName: string;
    directorLastName: string;
}
